import { useNavigate } from "react-router";

import consumerStyle from "consumer/consumer.module.css";
import step2Style from "../step2.module.css";
import { convert_time } from "consumer/@@@/convert_time";
import { convert_grade } from "consumer/@@@/convert_grade";
import React from "react";

export default function List(props) {
	const navigate = useNavigate();

	const { gradeList, eventList, academyInfo, inProgressMap, reloadEvent } = props;

	const onNavigate = (event, schedule) => {
		navigate("/step3", {
			state: {
				branch_id: academyInfo["BranchID"],
				branch_name: academyInfo["BranchName"],
				event_id: event["id"],
				schedule_id: schedule["id"],
			},
		});

		reloadEvent(schedule["id"]);
	};

	return (
		<div className={step2Style["listWrap"]}>
			{eventList.map((value, index) => {
				let scheduleList = value["Schedules"];

				return (
					<div
						key={index}
						style={{
							marginBottom: "10px",
						}}
					>
						<div className={step2Style["eventName"]}>[{value["name"]}]</div>

						<div className={step2Style["scheduleWrap"]}>
							{scheduleList.map((v, i) => {
								let schedule_id = v.id;
								let addcount = inProgressMap[schedule_id] || 0;
								let currentCount = v.currentUserCount + addcount;

								let isDisabled = currentCount >= v.targetNumber;

								return (
									<div
										key={i}
										className={step2Style["schedule"]}
										style={{
											opacity: isDisabled ? 0.5 : 1,
											cursor: isDisabled ? "not-allowed" : "pointer",
											pointerEvents: isDisabled ? "none" : "auto",
										}}
										onClick={() => {
											if (isDisabled) return;
											onNavigate(value, v);
										}}
									>
										<div>{v["targetDate"]}</div>
										<div>{convert_time(v["targetTime"])}</div>
										<div>
											{(function () {
												const payment = v["payment"];
												if (payment === 0) {
													return "무료";
												} else {
													return `${payment}원`;
												}
											})()}
										</div>
										<div>
											{currentCount}/{v.targetNumber}
										</div>
										<div className={step2Style["gradeWrap"]}>
											{JSON.parse(v["targetGrades"]).map((a, b) => {
												return (
													<div key={b} className={step2Style["grade"]}>
														{convert_grade({
															grade_list: gradeList,
															grade: a,
														})}
													</div>
												);
											})}
										</div>
									</div>
								);
							})}
						</div>
					</div>
				);
			})}

			{eventList.length === 0 && <div className={consumerStyle["alarm"]}>등록된 일정이 없습니다.</div>}
		</div>
	);
}
